import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from '../common/modules/shared';
import { CoreModule } from '../common/modules/core';
import { AdminModule } from '../common/modules/admin';

import { SessionService } from '../common/modules/admin/services/SessionService';
import { LocalNetworkService } from '../common/modules/core/services/LocalNetworkService';
import { AppComponent } from './AppComponent';
import { routing } from './AppRouting';
import { NavigateComponent } from './navigate-page/NavigateComponent';
import { UserService } from '../common/modules/user/services/UserService';

@NgModule({
    imports: [
        BrowserModule,
        CoreModule,
        SharedModule,
        AdminModule,
        routing
    ],
    declarations: [
        AppComponent,
        NavigateComponent,
    ],
    providers: [
        SessionService,
        LocalNetworkService,
        UserService
    ],
    bootstrap: [
        AppComponent,
    ]
})

export class AppModule {}


// WEBPACK FOOTER //
// ./src/auth/AppModule.ts